import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=2bc92f3c&scoped=true&"
import script from "./addPhone.vue?vue&type=script&lang=js&"
export * from "./addPhone.vue?vue&type=script&lang=js&"
import style0 from "./addPhone.vue?vue&type=style&index=0&id=2bc92f3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc92f3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc92f3c')) {
      api.createRecord('2bc92f3c', component.options)
    } else {
      api.reload('2bc92f3c', component.options)
    }
    module.hot.accept("./addPhone.vue?vue&type=template&id=2bc92f3c&scoped=true&", function () {
      api.rerender('2bc92f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myInformation/addPhone.vue"
export default component.exports